import { CrossLarge as IconComponent } from '@adobe/react-spectrum-ui/dist/CrossLarge.js';
import { UIIcon } from '@react-spectrum/icon';
import React from 'react';
export default function CrossLarge(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}